<template>
  <div v-loading="pageLoading">
    <div>
      <h3>{{ title }}</h3>
      <p>時間：{{ time }}</p>
      <p>活動發佈人員：{{ name }}</p>
    </div>
    <hr />
    <div id="editor" ref="editor"></div>
    <el-button class="btn"
               @click="$router.back(-1)">返 回</el-button>
    <el-button type="primary"
               @click="submit"
               style="display: block;margin: auto;margin-top: 10px;">上傳花絮</el-button>
  </div>
</template>

<script>
import WangEditor from 'wangeditor';
export default {
  name: 'foot',
  data () {
    return {
      pageLoading: false,
      title: '',
      time: '',
      name: ''
    };
  },
  methods: {
    submit () {
      let editor = this.editor;
      var content = editor.txt.html();
      if (content == '' || content == '<p></p>' || content == '<p><br></p>') {
        this.$message({
          showClose: true,
          message: '请新增内容',
          type: 'warning'
        });
        return;
      }
      let img = editor.$textElem.elems[0].getElementsByTagName('img');
      let video = editor.$textElem.elems[0].getElementsByTagName('video');
      let addImg = [];
      for (let i = 0; i < img.length; i++) {
        addImg.push(img[i].src);
      }
      for (let i = 0; i < video.length; i++) {
        addImg.push(video[i].src);
      }
      console.log(addImg);

      //这里应该post 提交
      this.pageLoading = true
      this.axios({
        url: '/manage/UploadEventTidbits',
         method: "post",
         params: {
          addImg:this.addImg,
          content:content,
          id: sessionStorage.getItem('activityId')
        }
      }).then(res => {
        if (res) {
          this.$message({
            message: '發佈成功',
            type: 'success'
          });
          setTimeout(() => {
            this.$router.back()
          }, 1000)
        } else {
          this.pageLoading = false
        }
      });
    }
  },
  mounted () {
    $('#pageHead').text('上傳花絮');
    this.editor = new WangEditor(this.$refs.editor); //这个地方传入div元素的id 需要加#号
    this.editor.config.uploadImgServer = this.URL + '/manage/uploadActivityFile';
    this.editor.config.uploadImgMaxLength = 1;
    this.editor.config.uploadFileName = 'file';
    (this.editor.config.uploadImgHeaders = {
      login_token: sessionStorage.getItem('token')
    });
      (this.editor.config.uploadImgMaxLength = 1);
    this.editor.config.uploadImgParams = {
      login_token: sessionStorage.getItem('token')
    };
    this.editor.config.uploadImgHooks = {
      customInsert: (insertImg, result) => {
        insertImg(result.result);
      }
    };

  this.editor.config.uploadVideoServer = this.URL + '/manage/uploadActivityFile';
  (this.editor.config.uploadVideoHeaders = {
    login_token: sessionStorage.getItem('token')
  });
  this.editor.config.uploadVideoMaxSize = (1 * 1024 * 1024 * 1024)/4;
  this.editor.config.uploadVideoTimeout =  1000 * 60 * 5;
  this.editor.config.uploadVideoHooks={
      customInsert: function(insertVideoFn, result) {
        // result 即服务端返回的接口
        console.log('customInsert', result);

        // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
        insertVideoFn(result.result);
    }
} 
    
    // // 配置 onchange 事件
    // this.editor.change = function() {
    // 	console.log(this.txt.html());
    // };
    this.editor.create(); // 生成编辑器
    this.editor.txt.html(''); //注意：这个地方是txt  不是官方文档中的$txt
  },
  created () {
    var id = sessionStorage.getItem('activityId');
    this.axios({
      url: '/manage/getManActivity',
      params: {
        id: id
      }
    }).then(res => {
      if (res) {
        let msg = res.result[0];
        this.title = msg.activityName;
        this.name = msg.manUserName;
        this.time = msg.activityStartTime + ' —— ' + msg.activityEndTime;
      }
    });
  }
};
</script>

<style scoped>
p {
  color: #999;
}

hr {
  border-bottom: none;
  border-top: 3px solid #999;
}

.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
